
import { useState, useEffect } from "react";
export const useMobile = () => {
  const [isMobile, setMobile] = useState(false);
  useEffect(() => {
    window.addEventListener('resize', () => {
      setMobile(document.body.clientWidth < 768);
    });
    setMobile(document.body.clientWidth < 768);
  }, []);
  return isMobile;
}